/**
 * 判断是否是微信环境
 */
export const isWechat = (): boolean => navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
